import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { Colors, Fonts, FontWeights } from '../constants'
import { Close } from './icons'
import { PageContent } from './page'

export type HeaderTheme = 'dark'

interface Props {
  onClose?: () => void
  title?: string
  disableClose?: boolean
  children: ReactNode
  className?: string
  headerTheme?: HeaderTheme
}

export function Modal({ onClose, title, disableClose, children, className, headerTheme }: Props) {
  function onBackgroundClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    if (e.target === e.currentTarget && onClose) {
      onClose()
    }
  }

  return (
    <Background onClick={onBackgroundClick}>
      <PageContentStyled className={className}>
        <Header headerTheme={headerTheme}>
          {title && <Title>{title}</Title>}
          {!disableClose && (
            <CloseButton onClick={onClose}>
              <Close />
            </CloseButton>
          )}
        </Header>
        <ChildrenContainer>{children}</ChildrenContainer>
      </PageContentStyled>
    </Background>
  )
}

const PageContentStyled = styled(PageContent)`
  max-height: 600px;
  display: flex;
  flex-direction: column;
`

const Background = styled.div`
  padding: 68px 0;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(2px) grayscale(50%) invert(30%);
  z-index: 100000;

  @media (max-height: 850px) {
    display: flex;
    flex-direction: column;
    justify-content: center;

    & div:first-child {
      margin-top: 0;
    }

    @media (max-height: 512px) {
      padding: 20px 0;
    }
  }
`

const ChildrenContainer = styled.div`
  flex: 1;
  overflow-y: auto;
`

const Header = styled.div<{ headerTheme?: HeaderTheme }>`
  padding: 0 20px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 58px;
  background: ${({ headerTheme }) => (headerTheme === 'dark' ? 'rgb(57, 57, 57);' : 'rgb(91, 101, 119);')}
  background: ${({ headerTheme }) =>
    headerTheme === 'dark'
      ? 'linear-gradient(0deg, rgba(57, 57, 57, 1) 0%, rgba(28, 28, 28, 1) 100%);'
      : 'linear-gradient(0deg, rgba(91, 101, 119, 1) 0%, rgba(62, 70, 86, 1) 100%);'}
`

const Title = styled.h1`
  color: ${Colors.White};
  font-size: 20px;
  font-family: ${Fonts.Header};
  font-weight: ${FontWeights.Semibold};
  text-transform: uppercase;
`

const CloseButton = styled.button`
  margin: 0;
  padding: 0;
  color: ${Colors.White};
  background: none;
  outline: none;
  border: none;
  cursor: pointer;
`
